"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorNotificationTime = exports.dateSearchCharacter = exports.LoadPolicyDataType = exports.EditRolesDetailsType = exports.editRolesListType = exports.editPermissionsListType = exports.EditPermissionActionsType = exports.EditPermissionDetailsType = exports.EditNotificationType = exports.EditPolicyType = exports.EditTokensType = exports.EditServiceIdentitiesType = exports.EditGroupsType = exports.EditUsersType = exports.EditFetchServiceIdentityType = exports.EditFetchTokenType = exports.EditFetchGroupType = exports.EditFetchUserType = exports.translatedStrings = void 0;

var _externalization = require("../../../packages/policy-management/externalization");

var translatedStrings = {
  loadingPolicy: (0, _externalization.translate)('POLICIES_LOADING'),
  resetEditTitle: (0, _externalization.translate)('POLICIES_MODULE.RESET_EDIT_TITLE'),
  resetEditMessage: (0, _externalization.translate)('POLICIES_MODULE.RESET_EDIT_MESSAGE'),
  resetEditPrimaryBtn: (0, _externalization.translate)('POLICIES_MODULE.RESET_EDIT_PRIMARY_BTN'),
  resetEditSecondaryBtn: (0, _externalization.translate)('POLICIES_MODULE.RESET_EDIT_SECONDARY_BTN'),
  inlineType: (0, _externalization.translate)('INLINE'),
  preDefinedType: (0, _externalization.translate)('PRE_DEFINED'),
  policyUpdateSuccess: (0, _externalization.translate)('POLICIES_MODULE.POLICY_UPDATE_SUCCESS'),
  editingPolicy: (0, _externalization.translate)('POLICIES_MODULE.EDITING_POLICY'),
  errorGetRolesList: function errorGetRolesList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.ERROR_GET_ROLE_LIST', {
      reason: reason
    });
  },
  errorGetPermissionsList: function errorGetPermissionsList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.ERROR_GET_PERMISSION_LIST', {
      reason: reason
    });
  },
  warningGetRolesList: function warningGetRolesList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.WARNING_GET_ROLE_LIST', {
      reason: reason
    });
  },
  warningGetPermissionsList: function warningGetPermissionsList(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.WARNING_GET_PERMISSION_LIST', {
      reason: reason
    });
  },
  errorGetPolicyData: function errorGetPolicyData(reason) {
    return (0, _externalization.translate)('POLICIES_MODULE.VIEW_POLICY_ERROR_MESSAGE_WITH_REASON', {
      reason: reason
    });
  }
};
exports.translatedStrings = translatedStrings;
var EditFetchUserType = {
  FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
  FETCH_USER_REQUEST_LOADING: 'FETCH_USER_REQUEST_LOADING',
  FETCH_USER_REQUEST_SUCCESS: 'FETCH_USER_REQUEST_SUCCESS',
  FETCH_USER_REQUEST_FAILURE: 'FETCH_USER_REQUEST_ERROR'
};
exports.EditFetchUserType = EditFetchUserType;
var EditFetchGroupType = {
  FETCH_GROUP_REQUEST: 'FETCH_GROUP_REQUEST',
  FETCH_GROUP_REQUEST_LOADING: 'FETCH_GROUP_REQUEST_LOADING',
  FETCH_GROUP_REQUEST_SUCCESS: 'FETCH_GROUP_REQUEST_SUCCESS',
  FETCH_GROUP_REQUEST_FAILURE: 'FETCH_GROUP_REQUEST_ERROR'
};
exports.EditFetchGroupType = EditFetchGroupType;
var EditFetchTokenType = {
  FETCH_TOKEN_REQUEST: 'FETCH_TOKEN_REQUEST',
  FETCH_TOKEN_REQUEST_LOADING: 'FETCH_TOKEN_REQUEST_LOADING',
  FETCH_TOKEN_REQUEST_SUCCESS: 'FETCH_TOKEN_REQUEST_SUCCESS',
  FETCH_TOKEN_REQUEST_FAILURE: 'FETCH_TOKEN_REQUEST_ERROR'
};
exports.EditFetchTokenType = EditFetchTokenType;
var EditFetchServiceIdentityType = {
  FETCH_SERVICE_IDENTITY_REQUEST: 'FETCH_SERVICE_IDENTITY_REQUEST',
  FETCH_SERVICE_IDENTITY_REQUEST_LOADING: 'FETCH_SERVICE_IDENTITY_REQUEST_LOADING',
  FETCH_SERVICE_IDENTITY_REQUEST_SUCCESS: 'FETCH_SERVICE_IDENTITY_REQUEST_SUCCESS',
  FETCH_SERVICE_IDENTITY_REQUEST_FAILURE: 'FETCH_SERVICE_IDENTITY_REQUEST_ERROR'
};
exports.EditFetchServiceIdentityType = EditFetchServiceIdentityType;
var EditUsersType = {
  EDIT_USERS_REQUEST: 'EDIT_USERS_REQUEST',
  EDIT_USERS_LOADING: 'EDIT_USERS_LOADING',
  EDIT_USERS_SUCCESS: 'EDIT_USERS_SUCCESS',
  EDIT_USERS_FAILURE: 'EDIT_USERS_ERROR'
};
exports.EditUsersType = EditUsersType;
var EditGroupsType = {
  EDIT_GROUPS_REQUEST: 'EDIT_GROUPS_REQUEST',
  EDIT_GROUPS_LOADING: 'EDIT_GROUPS_LOADING',
  EDIT_GROUPS_SUCCESS: 'EDIT_GROUPS_SUCCESS',
  EDIT_GROUPS_FAILURE: 'EDIT_GROUPS_FAILURE'
};
exports.EditGroupsType = EditGroupsType;
var EditServiceIdentitiesType = {
  EDIT_SERVICE_IDENTITY_REQUEST: 'EDIT_SERVICE_IDENTITY_REQUEST',
  EDIT_SERVICE_IDENTITY_LOADING: 'EDIT_SERVICE_IDENTITY_LOADING',
  EDIT_SERVICE_IDENTITY_SUCCESS: 'EDIT_SERVICE_IDENTITY_SUCCESS',
  EDIT_SERVICE_IDENTITY_FAILURE: 'EDIT_SERVICE_IDENTITY_FAILURE'
};
exports.EditServiceIdentitiesType = EditServiceIdentitiesType;
var EditTokensType = {
  EDIT_TOKENS_REQUEST: 'EDIT_TOKENS_REQUEST',
  EDIT_TOKENS_LOADING: 'EDIT_TOKENS_LOADING',
  EDIT_TOKENS_SUCCESS: 'EDIT_TOKENS_SUCCESS',
  EDIT_TOKENS_FAILURE: 'EDIT_TOKENS_FAILURE'
};
exports.EditTokensType = EditTokensType;
var EditPolicyType = {
  EDIT_POLICY_REQUEST: 'EDIT_POLICY_REQUEST',
  EDIT_POLICY_LOADING: 'EDIT_POLICY_LOADING',
  EDIT_POLICY_SUCCESS: 'EDIT_POLICY_SUCCESS',
  EDIT_POLICY_FAILURE: 'EDIT_POLICY_FAILURE'
};
exports.EditPolicyType = EditPolicyType;
var EditNotificationType = {
  EDIT_OPEN_NOTIFICATION: 'OPEN_NOTIFICATION',
  EDIT_CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION'
};
exports.EditNotificationType = EditNotificationType;
var EditPermissionDetailsType = {
  EDIT_PERMISSION_DETAILS_REQUEST: 'EDIT_PERMISSION_DETAILS_REQUEST',
  EDIT_PERMISSION_DETAILS_LOADING: 'EDIT_PERMISSION_DETAILS_LOADING',
  EDIT_PERMISSION_DETAILS_SUCCESS: 'EDIT_PERMISSION_DETAILS_SUCCESS',
  EDIT_PERMISSION_DETAILS_FAILURE: 'EDIT_PERMISSION_DETAILS_FAILURE'
};
exports.EditPermissionDetailsType = EditPermissionDetailsType;
var EditPermissionActionsType = {
  EDIT_PERMISSION_ACTIONS_REQUEST: 'EDIT_PERMISSION_ACTIONS_REQUEST',
  EDIT_PERMISSION_ACTIONS_LOADING: 'EDIT_PERMISSION_ACTIONS_LOADING',
  EDIT_PERMISSION_ACTIONS_SUCCESS: 'EDIT_PERMISSION_ACTIONS_SUCCESS',
  EDIT_PERMISSION_ACTIONS_FAILURE: 'EDIT_PERMISSION_ACTIONS_FAILURE',
  EDIT_PERMISSION_ACTIONS_RESET: 'EDIT_PERMISSION_ACTIONS_RESET'
};
exports.EditPermissionActionsType = EditPermissionActionsType;
var editPermissionsListType = {
  RECURSIVE_EDIT_PERMISSIONS_LIST_REQUEST: 'RECURSIVE_EDIT_PERMISSIONS_LIST_REQUEST',
  RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING: 'RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING',
  RECURSIVE_EDIT_PERMISSIONS_LIST_SUCCESS: 'RECURSIVE_EDIT_PERMISSIONS_LIST_SUCCESS',
  RECURSIVE_EDIT_PERMISSIONS_LIST_FAILURE: 'RECURSIVE_EDIT_PERMISSIONS_LIST_FAILURE',
  RECURSIVE_EDIT_PERMISSIONS_LIST_RESET: 'RECURSIVE_EDIT_PERMISSIONS_LIST_RESET',
  RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING_DISABLE: 'RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING_DISABLE'
};
exports.editPermissionsListType = editPermissionsListType;
var editRolesListType = {
  RECURSIVE_EDIT_ROLES_LIST_REQUEST: 'RECURSIVE_EDIT_ROLES_LIST_REQUEST',
  RECURSIVE_EDIT_ROLES_LIST_LOADING: 'RECURSIVE_EDIT_ROLES_LIST_LOADING',
  RECURSIVE_EDIT_ROLES_LIST_SUCCESS: 'RECURSIVE_EDIT_ROLES_LIST_SUCCESS',
  RECURSIVE_EDIT_ROLES_LIST_FAILURE: 'RECURSIVE_EDIT_ROLES_LIST_FAILURE',
  RECURSIVE_EDIT_ROLES_LIST_RESET: 'RECURSIVE_EDIT_ROLES_LIST_RESET',
  RECURSIVE_EDIT_ROLES_LIST_LOADING_DISABLE: 'RECURSIVE_EDIT_ROLES_LIST_LOADING_DISABLE'
};
exports.editRolesListType = editRolesListType;
var EditRolesDetailsType = {
  EDIT_ROLES_DETAILS_REQUEST: 'EDIT_ROLES_DETAILS_REQUEST',
  EDIT_ROLES_DETAILS_LOADING: 'EDIT_ROLES_DETAILS_LOADING',
  EDIT_ROLES_DETAILS_SUCCESS: 'EDIT_ROLES_DETAILS_SUCCESS',
  EDIT_ROLES_DETAILS_FAILURE: 'EDIT_ROLES_DETAILS_FAILURE'
};
exports.EditRolesDetailsType = EditRolesDetailsType;
var LoadPolicyDataType = {
  EDIT_LOAD_POLICY_REQUEST: 'EDIT_LOAD_POLICY_REQUEST',
  EDIT_LOAD_POLICY_LOADING: 'EDIT_LOAD_POLICY_LOADING',
  EDIT_LOAD_POLICY_SUCCESS: 'EDIT_LOAD_POLICY_SUCCESS',
  EDIT_LOAD_POLICY_FAILURE: 'EDIT_LOAD_POLICY_FAILURE',
  EDIT_LOAD_POLICY_RESET: 'EDIT_LOAD_POLICY_RESET',
  OPEN_NOTIFICATION: 'OPEN_NOTIFICATION',
  EDIT_LOAD_POLICY_JSON_REQUEST: 'EDIT_LOAD_POLICY_JSON_REQUEST',
  EDIT_LOAD_POLICY_JSON_LOADING: 'EDIT_LOAD_POLICY_JSON_LOADING',
  EDIT_LOAD_POLICY_JSON_SUCCESS: 'EDIT_LOAD_POLICY_JSON_SUCCESS',
  EDIT_LOAD_POLICY_JSON_FAILURE: 'EDIT_LOAD_POLICY_JSON_FAILURE',
  EDIT_LOAD_POLICY_JSON_RESET: 'EDIT_LOAD_POLICY_JSON_RESET'
};
exports.LoadPolicyDataType = LoadPolicyDataType;
var dateSearchCharacter = '-';
exports.dateSearchCharacter = dateSearchCharacter;
var errorNotificationTime = 3000;
exports.errorNotificationTime = errorNotificationTime;